import { findBestAvailableLanguage } from 'react-native-localize'

// Converts en-GB to en
const getLanguageCode = (languageTag: string) => languageTag.split('-')[0]

const getLocale = (
  availableLanguages: string[],
  fallbackLanguage: string,
  userLocale: string
) => {
  const languageCodes = Array.from(
    new Set(availableLanguages.map(getLanguageCode))
  )

  let bestLanguage: ReturnType<typeof findBestAvailableLanguage>

  try {
    bestLanguage = findBestAvailableLanguage([
      ...availableLanguages,
      ...languageCodes,
    ])
  } catch {
    // Unsupported browser i.e. IE11 (See what I did there :trollface:)
  }

  if (!bestLanguage) {
    return fallbackLanguage
  }

  // Get the full tag of the best language, e.g. fr becomes fr-CA
  // This is needed because if the device is set in fr-FR and it is not a supported
  // language the bestLanguage will be "fr" (assuming we support fr-CA)
  const bestLanguageTag =
    availableLanguages.find((lang) =>
      lang.startsWith(bestLanguage!.languageTag)
    ) || fallbackLanguage

  // If the user language is not available falls back to the default locale
  const initialLocale =
    availableLanguages.indexOf(userLocale) > -1 ? userLocale : bestLanguageTag

  return initialLocale
}

export default getLocale

// exported for testing
export { getLanguageCode as _getLanguageCode }
